import React, {useState} from 'react';
import {Button, Card, CardBody, Col, FormGroup, Input, Label, Popover, PopoverBody, PopoverHeader} from "reactstrap";
import {Row} from "react-bootstrap";
import {paymentCalculation} from "../../setting/calculation";
import {CURRENCY_SYMBOL} from "../../../../../utils/common";
import OrderDiscount from "./orderDiscount";
import {
    setOrderDiscountDialog,
    setSearchProductDialog,
    setShippingDiscountDialog, setTaxDialog
} from "../../../store/draftOrderSlice";
import {useDispatch} from "react-redux";
import OrderShipment from "./orderShipment";
import OrderTax from "./orderTax";

const PopoverBasicItem = (props) => {
    const {id, btntext, Popoverbody} = props;
    const [popover, setPopover] = useState(false)
    const Toggle = () => setPopover(!popover);
    return (
        <>
            <a className="a-text-color" id="tax">Tax</a>
            <Popover
                placement="right"
                isOpen={popover}
                target="tax"
                toggle={Toggle}
                trigger="click"
            >
                <PopoverBody>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label className="col-form-label">taxs are Automatically Calculated</Label>
                                <Col md="12">
                                    <div className="checkbox checkbox-dark">
                                        <Input id="is_tax" type="checkbox"  onChange={(e)=>{

                                        }} defaultChecked={false}/>
                                        <Label for="is_tax">Charge Taxes</Label>
                                    </div>
                                </Col>

                            </FormGroup>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Button color="default"  className="btn btn-default btn-sm" onClick={Toggle}>Cancel</Button>
                        </Col>
                        <Col md={6}>
                            <Button  color="primary" className="btn btn-primary btn-sm">Apply</Button>
                        </Col>
                    </Row>
                </PopoverBody>

            </Popover>
        </>
    );
};

function OrderPayment(props) {
    const dispatch = useDispatch();
    const {setValue, trigger, getValues, currencySymbol = CURRENCY_SYMBOL} = props;
    const payment = paymentCalculation(getValues);

    return (
        <Card>
            <CardBody>
                <Row>
                    <Col md="12">
                        <h6>Payment</h6>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <table className="table table-borderless">
                            <tbody>
                            <tr>
                                <td>Sub Total</td>
                                <td></td>
                                <td align="right">{currencySymbol}{payment.subTotal}</td>
                            </tr>
                            <tr>
                                <td><a className="a-text-color" onClick={() => {
                                    const obj = {
                                        props: {isOpen: true},
                                        type: getValues('discount') ? "edit" : "new",
                                        data: getValues('discount')
                                    }
                                    dispatch(setOrderDiscountDialog(obj));
                                }}>{getValues('discount') ? "Edit" : "Add"} Discount</a></td>
                                <td>{getValues('discount') ? (getValues('discount').reason ? getValues('discount').reason : "----") : "----"}</td>
                                <td align="right">{currencySymbol}{payment.discountPrice}</td>
                            </tr>
                            <tr>
                                <td><a className="a-text-color" onClick={() => {
                                    const obj = {
                                        props: {isOpen: true},
                                        type: getValues('shipping') ? "edit" : "new",
                                        data: getValues('shipping')
                                    }
                                    dispatch(setShippingDiscountDialog(obj));

                                }}>{getValues('shipping') ? "Edit" : "Add"} Shipment</a></td>
                                <td>{getValues('shipping') ? (getValues('shipping').rate_name ? getValues('shipping').rate_name : "----") : "----"}</td>
                                <td align="right">{currencySymbol}{payment.shippingPrice}</td>
                            </tr>
                            <tr>
                                <td><a className="a-text-color" onClick={() => {
                                    const obj = {
                                        props: {isOpen: true},
                                        type: getValues('tax') ? "edit" : "new",
                                        data: getValues('tax')
                                    }
                                    dispatch(setTaxDialog(obj));

                                }}>{getValues('tax') ? "Edit" : "Add"} Tax</a></td>
                                <td>{getValues('tax') ? (getValues('tax').rate_name ? getValues('tax').rate_name : "----") : "----"}</td>
                                <td align="right">{currencySymbol}{payment.taxPrice}</td>
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td colSpan="2" align="right">{currencySymbol}{payment.total}</td>
                            </tr>
                            </tbody>
                        </table>
                    </Col>
                </Row>

            </CardBody>
        </Card>
    );
}

export default OrderPayment;